<template>
  <div>
    <WCSpinner v-if="loading" position="window-center" size="xl" />
    <!-- START : Contact us form -->
    <form @submit.prevent="submit">
      <h2 class="pb-1 border-bottom">{{ $t('sendUsAMessage') }}</h2>
      <WCFormGroup :field="$v.form.name">
        <WCLabel for="name">{{ $t('name') }}</WCLabel>
        <WCInput id="name" />
        <WCValidationErrors />
      </WCFormGroup>
      <WCFormGroup :field="$v.form.email">
        <WCLabel for="email">{{ $t('emailAddress') }}</WCLabel>
        <WCInput id="email" />
        <WCValidationErrors />
      </WCFormGroup>
      <WCFormGroup :field="$v.form.subject">
        <WCLabel for="subject">{{ $t('subject') }}</WCLabel>
        <WCInput id="subject" />
        <WCValidationErrors />
      </WCFormGroup>
      <WCFormGroup :field="$v.form.message">
        <WCLabel for="message">{{ $t('message') }}</WCLabel>
        <WCTextArea id="message" rows="7" />
        <WCValidationErrors />
      </WCFormGroup>
      <WCInvisibleRecaptcha ref="recaptcha" />
      <button class="btn btn-primary" :disabled="$v.form.$invalid || loading">
        {{ $t('sendMessage') }}
      </button>
    </form>
    <!-- END : Contact us form -->
  </div>
</template>

<script>
import axios from 'axios';
import { required, email } from 'vuelidate/lib/validators';
import { WCFormGroup, WCLabel, WCInput, WCTextArea, WCValidationErrors } from '@/modules/forms';
import WCInvisibleRecaptcha from '@/modules/recaptcha/components/WCInvisibleRecaptcha/WCInvisibleRecaptcha.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';

export default {
  name: 'WCContactUsForm',
  components: {
    WCFormGroup,
    WCLabel,
    WCInput,
    WCTextArea,
    WCValidationErrors,
    WCInvisibleRecaptcha,
    WCSpinner,
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      subject: {
        required,
      },
      message: {
        required,
      },
    },
  },
  methods: {
    /**
     * Method to display toast
     */
    showToast(variation, message) {
      return ToastService.open(WCSimpleToast, {
        props: {
          variant: variation,
          title: this.$t('contactUs'),
          message,
        },
        timeout: 7000,
      });
    },
    async submit() {
      this.loading = true;
      try {
        const payload = {
          ...this.form,
          recaptcha: await this.$refs.recaptcha.execute(),
        };

        const response = await axios.post('api/contact', payload);
        if (response?.data?.message === 'Success') {
          this.showToast('success', this.$t('messageSentSuccess'));
        } else {
          this.showToast('danger', response?.data?.message || this.$t('messageSentFailure'));
        }
        this.reset();
      } catch (error) {
        console.error(error);
        this.showToast('danger', this.$t('messageSentFailure'));
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.form = {
        name: '',
        email: '',
        subject: '',
        message: '',
      };
      this.$v.form.$reset();

      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style scoped></style>
